import ClientCallOut from '../pages/ClientCallOuts';
import ClientCallOutDashboard from '../pages/ClientCallOutDashboard';

const ccoDashboardRoute = {
  public: [],
  auth: [
    {
      name: 'cnc_client_call_out',
      path: '/dashboard/client-call-out',
      permissions: ['DAM', 'CNC-ADMIN', 'CNC-MANAGER', 'CNC-ANALYST'],
      component: ClientCallOutDashboard,
    },
    {
      name: 'my_cnc_client_call_out',
      path: '/dashboard/my-client-call-out',
      permissions: ['CNC-ADMIN', 'CNC-MANAGER', 'CNC-ANALYST'],
      component: ClientCallOut,
    },
  ],
};

export default ccoDashboardRoute;
